import api from '../../config';

const path = 'export/addison';

export default {
  get: (page, perPage) => api.get(`${path}`, { params: { page, per_page: perPage } }),
};
